// extracted by mini-css-extract-plugin
module.exports = {"Select":"Select_Select__10e4g","SelectBtn":"Select_SelectBtn__2KZcP","SelectContent":"Select_SelectContent__MLSjK","SelectItem":"Select_SelectItem__bQraJ"};